<header class="headerclass">
  <div>
    <app-accessibility-bar></app-accessibility-bar>
    <nav class="navbar navbar-expand-lg bg-white sidebar-link">
      <div class="container-fluid d-flex justify-content-between">
        <div class="d-flex align-items-center invert-dark-body">
          <a class="navbar-brand" routerLink="/">
            <img
              class="laplogo"
              src="/assets/images/mines.svg"
              alt="nationalemblem"
            />
            <img
              class="phnlogo"
              src="/assets/images/nationalemblem.svg"
              alt="nationalemblem"
            />
          </a>
          <a class="navbar-brand" routerLink="/">
            <div class="divider"></div>
          </a>
          <a class="navbar-brand" routerLink="/">
            <img src="/assets/images/jnardc.svg" alt="jnardc Logo" />
          </a>
          <a class="navbar-brand" routerLink="/">
            <img
              class="laplogo"
              src="/assets/images/Recyclinglogo.svg"
              alt="Government Logo"
            />
            <img
              class="phnlogo"
              src="/assets/images/reclogo.svg"
              alt="Government Logo"
            />
          </a>
        </div>
        <div
          class="d-flex justify-content-center align-items-center position-relative ms-auto gap-4"
        >
          <button
            class="navbar-toggler position-static ms-1"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div
            class="collapse navbar-collapse ms-2"
            id="navbarSupportedContent"
          >
            <ul class="navbar-nav d-flex gap-2">
              <li class="nav-item dropdown">
                <a
                  class="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  About Us
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" routerLink="/about-us"
                      >Recycling Promotion Division</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="/secretary-message"
                      >Secretary's Message</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item block d-flex justify-content-between align-items-center"
                      href="https://mines.gov.in/webportal/home"
                      target="_blank"
                      >Ministry of Mines
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="10"
                        height="10"
                        viewBox="0 0 10 10"
                        fill="none"
                      >
                        <path
                          d="M1.07692 10L0 8.92308L7.38462 1.53846H0.769231V0H10V9.23077H8.46154V2.61538L1.07692 10Z"
                          fill="#1C1B1F"
                        /></svg
                    ></a>
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="/vision-mission"
                      >Our Vision</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="/whoswho">Who's Who</a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="['/']"
                      [fragment]="'pillars'"
                    >
                      Key Pillars
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      [routerLink]="['/registration-benefits']"
                    >
                      Registration Benefits
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" [routerLink]="['/site-map']">
                      Site Map
                    </a>
                  </li>
                </ul>
              </li>
              <li class="nav-item dropdown position-relative">
                <div class="d-flex align-items-center">
                  <!-- Main Events Link -->
                  <a class="nav-link pe-1" [routerLink]="['/events']">Events</a>

                  <!-- Arrow Icon to Show Dropdown -->
                  <span
                    class="nav-link dropdown-toggle px-1"
                    style="cursor: pointer"
                  ></span>
                </div>

                <!-- Dropdown Menu (Always present in DOM) -->
                <ul class="dropdown-menu multi-level-menu">
                  <li class="dropdown-submenu">
                    <span class="dropdown-item">RPD Jnarddc</span>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/rpd_jnarddc/upcoming']"
                          >Upcoming Event</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/rpd_jnarddc/past']"
                          >Past Event</a
                        >
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown-submenu">
                    <span class="dropdown-item">Stakeholder</span>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/stakeholders/upcoming']"
                          >Upcoming Event</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/stakeholders/past']"
                          >Past Event</a
                        >
                      </li>
                    </ul>
                  </li>

                  <li class="dropdown-submenu">
                    <span class="dropdown-item">Ministry of Mines</span>
                    <ul class="dropdown-menu">
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/mines/upcoming']"
                          >Upcoming Event</a
                        >
                      </li>
                      <li>
                        <a
                          class="dropdown-item"
                          [routerLink]="['/events/mines/past']"
                          >Past Event</a
                        >
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              <li class="nav-item">
                <a
                  class="nav-link"
                  [routerLink]="['/']"
                  [fragment]="'getrating'"
                >
                  Get Rating
                </a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" role="button">
                  Incentive Scheme
                </a>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" routerLink="/incentive-scheme-page"
                      >About NCMM Incentive scheme</a
                    >
                  </li>
                  <li>
                    <a class="dropdown-item" routerLink="/incentive-guidelines"
                      >NCMM Incentive Guideline</a
                    >
                  </li>
                  <li>
                    <a
                      class="dropdown-item"
                      routerLink="/incentive-scheme-notifications"
                      >NCMM Incentive Notifications
                    </a>
                  </li>
                  <li>
                    <a
                      class="dropdown-item cursor-pointer"
                      (click)="onRegisterClick()"
                      >Apply for Incentive scheme</a
                    >
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/']" [fragment]="'gallery'">
                  Gallery
                </a>
              </li>
              @if (!user) {
                <li class="nav-item">
                  <button
                    class="appointmentbtn ms-lg-3"
                    (click)="onBookAppointment()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M14.25 3H13.5V1.5H12V3H6V1.5H4.5V3H3.75C2.925 3 2.25 3.675 2.25 4.5V15C2.25 15.825 2.925 16.5 3.75 16.5H14.25C15.075 16.5 15.75 15.825 15.75 15V4.5C15.75 3.675 15.075 3 14.25 3ZM14.25 15H3.75V7.5H14.25V15ZM3.75 6V4.5H14.25V6H3.75ZM5.25 9H12.75V10.5H5.25V9ZM5.25 12H10.5V13.5H5.25V12Z"
                        fill="#014221"
                      /></svg
                    >Book an appointment
                  </button>
                </li>
              }
            </ul>
          </div>

          <!-- <div class="search-container">
            <form
              class="d-flex search-form"
              role="search"
              [ngClass]="{ active: isSearchActive }"
            >
              <div class="input-wrapper">
                <input
                  class="form-control search-input"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <button
                  class="btn search-btn mx-2"
                  type="button"
                  (click)="toggleSearch()"
                >
                  <svg
                    *ngIf="!isSearchActive"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.26 13.27L20.99 19L19.5 20.49L13.77 14.76C12.7 15.53 11.41 16 10 16C6.41 16 3.5 13.09 3.5 9.5C3.5 5.91 6.41 3 10 3C13.59 3 16.5 5.91 16.5 9.5C16.5 10.91 16.03 12.2 15.26 13.27ZM10 5C7.51 5 5.5 7.01 5.5 9.5C5.5 11.99 7.51 14 10 14C12.49 14 14.5 11.99 14.5 9.5C14.5 7.01 12.49 5 10 5Z"
                      fill="#1E5126"
                    />
                  </svg>
                  <svg
                    *ngIf="isSearchActive"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M6 6L18 18M6 18L18 6"
                      stroke="#1E5126"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </form>
          </div> -->

          @if (user && user.email && user.name) {
            <div
              class="profile-card d-flex align-items-center"
              (click)="toggleUserDropdown($event)"
            >
              <div>
                <img
                  src="/assets/images/deepakkumar.svg"
                  alt="User Profile"
                  class="rounded-circle"
                />
              </div>
              <div>
                <p class="m-0 fw-bold">
                  {{ getShortUserName() }}
                </p>
                <p class="text-muted text-capitalize m-0">
                  {{ user.role || "Role" }}
                </p>
              </div>
              <span class="material-icons notranslate ml-2"
                >arrow_drop_down</span
              >
              @if (userDropdownVisible) {
                <div class="profile-dropdown" @dropdownAnimation>
                  <button (click)="rediretectTo(redirectButtonData.redirectTo)">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <mask
                        id="mask0_9671_90586"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="32"
                        height="32"
                      >
                        <rect width="32" height="32" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_9671_90586)">
                        <path
                          d="M14.325 16C14.6083 16 14.8458 15.9042 15.0375 15.7125C15.2292 15.5208 15.325 15.2833 15.325 15C15.325 14.7167 15.2292 14.4792 15.0375 14.2875C14.8458 14.0958 14.6083 14 14.325 14C14.0417 14 13.8042 14.0958 13.6125 14.2875C13.4208 14.4792 13.325 14.7167 13.325 15C13.325 15.2833 13.4208 15.5208 13.6125 15.7125C13.8042 15.9042 14.0417 16 14.325 16ZM11 16C11.2833 16 11.5208 15.9042 11.7125 15.7125C11.9042 15.5208 12 15.2833 12 15C12 14.7167 11.9042 14.4792 11.7125 14.2875C11.5208 14.0958 11.2833 14 11 14C10.7167 14 10.4792 14.0958 10.2875 14.2875C10.0958 14.4792 10 14.7167 10 15C10 15.2833 10.0958 15.5208 10.2875 15.7125C10.4792 15.9042 10.7167 16 11 16ZM17.675 16C17.9583 16 18.1958 15.9042 18.3875 15.7125C18.5792 15.5208 18.675 15.2833 18.675 15C18.675 14.7167 18.5792 14.4792 18.3875 14.2875C18.1958 14.0958 17.9583 14 17.675 14C17.3917 14 17.1542 14.0958 16.9625 14.2875C16.7708 14.4792 16.675 14.7167 16.675 15C16.675 15.2833 16.7708 15.5208 16.9625 15.7125C17.1542 15.9042 17.3917 16 17.675 16ZM21 16C21.2833 16 21.5208 15.9042 21.7125 15.7125C21.9042 15.5208 22 15.2833 22 15C22 14.7167 21.9042 14.4792 21.7125 14.2875C21.5208 14.0958 21.2833 14 21 14C20.7167 14 20.4792 14.0958 20.2875 14.2875C20.0958 14.4792 20 14.7167 20 15C20 15.2833 20.0958 15.5208 20.2875 15.7125C20.4792 15.9042 20.7167 16 21 16ZM8 20H24V10H8V20ZM16 24C14.35 24 12.9375 23.8875 11.7625 23.6625C10.5875 23.4375 10 23.1667 10 22.85V22H8C7.45 22 6.97917 21.8042 6.5875 21.4125C6.19583 21.0208 6 20.55 6 20V10C6 9.45 6.19583 8.97917 6.5875 8.5875C6.97917 8.19583 7.45 8 8 8H24C24.55 8 25.0208 8.19583 25.4125 8.5875C25.8042 8.97917 26 9.45 26 10V20C26 20.55 25.8042 21.0208 25.4125 21.4125C25.0208 21.8042 24.55 22 24 22H22V22.85C22 23.1667 21.4125 23.4375 20.2375 23.6625C19.0625 23.8875 17.65 24 16 24Z"
                          fill="#1C1B1F"
                        />
                      </g>
                    </svg>
                    <span> {{ redirectButtonData.text }} </span>
                  </button>
                  <button (click)="logout(); $event.stopPropagation()">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 -960 960 960"
                      width="24px"
                      fill="#000"
                    >
                      <path
                        d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z"
                      />
                    </svg>
                    <span> Logout </span>
                  </button>
                </div>
              }
            </div>
          } @else {
            <button class="greenbtn ms-lg-3" [routerLink]="['/auth']">
              Stakeholders Portal
            </button>
          }
        </div>
      </div>
    </nav>
  </div>
</header>
